const state = () => ({
    initialLoadComplete: false,
    visibilityState: 'visible',
});

const getters = {
};

const actions = {
    async initialLoadComplete({ commit }) {
        commit('setComplete');
    },
    someAction() {

    },
    hideSplash({ commit }) {
        commit('setHidden');
    },
};

const mutations = {
    setComplete(state) {
        state.initialLoadComplete = true;
        state.visibilityState = 'hiding';
    },
    setHidden(state) {
        state.visibilityState = 'hidden';
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};